import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Technology.css";
import center from "../../assests/Tech/xtlogo.png";
import ellipse from "../../assests/Tech/Ellipse.png";

// Import all tech icons dynamically
const techImages = Array.from({ length: 32 }, (_, i) =>
  require(`../../assests/Tech/tech${i + 1}-img.svg`)
);

const Technology: React.FC = () => {
  const rows = [0, 1, 2, 3]; // 4 marquee rows

  return (
    <section className="tech-container">
      {/* Heading */}
      <Container className="about-container text-center">
        <h3 className="master"> <span className="dot"></span>Technologies</h3>
        <h1 className="tech-over">Driving Excellence Through Technology</h1>
      </Container>

      {/* Tech Grid */}
      <Container fluid className="tech-grid">
        {/* Centered Card */}
        <div className="center-img-container">
          <div className="card-border">
            <div className="center-card">
              {/* Quadrants */}
              <div className="quadrant-grid">
                <div className="box green">
                  <span className="value">25+</span>
                  <span className="label">Programming Language</span>
                </div>
                <div className="box yellow">
                  <span className="value">08+</span>
                  <span className="label">Database</span>
                </div>
                <div className="box red">
                  <span className="value">12+</span>
                  <span className="label">Frameworks</span>
                </div>
                <div className="box blue">
                  <span className="value">18+</span>
                  <span className="label">Tools & Services</span>
                </div>
              </div>

              {/* Center Logo */}
              <div className="logo-center">
                <div className="ellipse-wrapper">
                  <img src={ellipse} alt="ellipse" className="ellipse-image" />
                  <img src={center} alt="center logo" className="center-logo" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Marquee Rows */}
        {rows.map((rowIdx) => (
          <Row
            key={rowIdx}
            className={`tech-row ${rowIdx % 2 === 0 ? "left" : "right"}`}
            style={{ position: "relative", zIndex: 1 }}
          >
            <Col xs={12}>
              <div className="marquee">
                <div className="marquee-content">
                  {techImages
                    .slice(rowIdx * 8, (rowIdx + 1) * 8)
                    .map((img, idx) => (
                      <img
                        src={img}
                        alt={`tech-${rowIdx * 8 + idx}`}
                        className="tech-icon"
                        key={idx}
                      />
                    ))}
                  {techImages
                    .slice(rowIdx * 8, (rowIdx + 1) * 8)
                    .map((img, idx) => (
                      <img
                        src={img}
                        alt={`tech-dup-${rowIdx * 8 + idx}`}
                        className="tech-icon"
                        key={`dup-${idx}`}
                      />
                    ))}
                </div>
              </div>
            </Col>
          </Row>
        ))}
      </Container>
    </section>
  );
};

export default Technology;
